// extracted by mini-css-extract-plugin
export var chevron = "CountryDropdown-module--chevron--c8592";
export var countryItem = "CountryDropdown-module--countryItem--64bed";
export var dropdown = "CountryDropdown-module--dropdown--b93ce";
export var flag = "CountryDropdown-module--flag--967b9";
export var open = "CountryDropdown-module--open--cd939";
export var regionSwitcher = "CountryDropdown-module--regionSwitcher--3a135";
export var toggleBtn = "CountryDropdown-module--toggleBtn--36a94";